import type { UseAsyncDataResT } from '@dr.pogodin/react-global-state';
import { time } from '@dr.pogodin/react-utils';

import { getArtist } from 'services/artists';

import type { ArtistT } from 'utils';

import { useAsyncCollection } from 'utils/global-state';

/**
 * Fetches a single Active artist by ID for public (unauthenticated) pages.
 * Uses the shared artists.map cache, so data loaded via usePublicArtistList
 * is reused without an extra network request.
 */
export function usePublicArtist(id: string): UseAsyncDataResT<ArtistT> {
  if (typeof id !== 'string') throw Error('Internal error');

  return useAsyncCollection(
    id,
    'artists.map',
    async () => getArtist(id, { asEndUser: true }),
    { maxage: time.YEAR_MS },
  );
}
